module.exports = __webpack_public_path__ + "static/media/box_safari.a4c4f081.svg";